export default function defaultListViewEditSave(data,way){

    const columns = data.get("columns")
    const activeColumns = columns.get("active")
    const columnsToServer = [];
    activeColumns.forEach(column => {
        if (column.def != undefined) {
          var relationship = column.def.get("relationship");
          if (relationship != module) {
            if (
              relationship != undefined &&
              relationship != null &&
              relationship != ""
            ) {
              relationship = relationship.split("/*");
            }
          } else {
            relationship = undefined;
          }
  
          columnsToServer.push({
            field: column.name,
            module: column.def.get("fieldModule"),
            width: column.def.get("width"),
            relationship: relationship
          });
        }
      });

    const params = {
        columns: columnsToServer,
        module: data.get("module"),
    }
    if(data.get("subpanel") == true){
      params["subpanel"] = true
      params["parent"] = data.get("parent")
    }
    this.load()
    this.rest.post("defaultListViewSave",params,ret => {
        if(ret.state == true){
          this.popupHide();
          this.route();
        }
    }) 
}